export const DEFAULT_FONT_FAMILY = 'Plus Jakarta Sans'

/** Trusts server-normalized config; only trims and falls back when empty. */
export function resolveShellFontFamily(fontFamily: string | null | undefined): string {
  const normalized = fontFamily?.trim()
  return normalized || DEFAULT_FONT_FAMILY
}

export function getGoogleFontsHref(fontFamilies: string | readonly string[]): string {
  const families = Array.isArray(fontFamilies) ? fontFamilies : [fontFamilies]
  const normalizedFamilies = [...new Set(families.map(resolveShellFontFamily))]

  const params = new URLSearchParams()
  params.set('display', 'swap')

  for (const family of normalizedFamilies) {
    params.append('family', `${family}:wght@300;400;500;600;700`)
  }

  return `https://fonts.googleapis.com/css2?${params.toString()}`
}

export function getShellFontStack(fontFamily: string): string {
  const resolvedFontFamily = resolveShellFontFamily(fontFamily)
  const escapedFontFamily = resolvedFontFamily.replaceAll("'", "\\'")
  const escapedDefaultFontFamily = DEFAULT_FONT_FAMILY.replaceAll("'", "\\'")
  return resolvedFontFamily === DEFAULT_FONT_FAMILY
    ? `'${escapedDefaultFontFamily}', sans-serif`
    : `'${escapedFontFamily}', '${escapedDefaultFontFamily}', sans-serif`
}
